import CHART_TYPES from '../../charts'

import Partners from '../../../../crm/enums/partner-enum'

export default {
  overviewCe: {
    charts: [
      {
        type: CHART_TYPES.CARD,
        name: 'totalemailaccountscreated',
        title: 'Total Accounts Created'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'totalaccountswithcampaigns',
        title: 'Total Accounts with Campaigns'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'totalaccountswithcampaignssend',
        title: 'Total Accounts with Campaigns Sent'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'totalcampaignscreated',
        title: 'Total Campaigns Created'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'totalcampaignssend',
        title: 'Total Campaigns Sent'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'totalcontactscreated',
        title: 'Total Contacts Subscribed',
        tooltip: 'These are all the Contacts of Creative Email accounts that are subscribed (permission to send mail)'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'totalsuspendedaccounts',
        title: 'Total Suspended Accounts',
        tooltip: 'These are all the Constant Contact accounts that have been suspended because of compliance reasons.'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'totalsuspendedaccountsrate',
        title: 'Percentage of Suspended Accounts',
        tooltip: 'The percentage of accounts that have been suspended because of compliance reasons.',
        suffix: '%'
      },

      {
        className: 'grid-col-8'
      },

      {
        type: CHART_TYPES.PIE,
        name: 'accountswithcontacts',
        title: 'List size'
      },
      {
        type: CHART_TYPES.PIE,
        name: 'campaignstargetaudience',
        title: 'Nr. of Recipients'
      },
      {
        className: 'grid-col-8'
      },
      {
        type: CHART_TYPES.GRAPH,
        name: 'AccountTotalsPerDay',
        title: 'Accounts totals',
        tooltip: ['Total Accounts Created: shows the accumulated number of CTCT Accounts created', 'Total Accounts with Campaigns: shows the accumulated number of CTCT Accounts that have at least 1 campaign', 'Total Accounts with Campaigns Sent: shows accumulated number of  CTCT Accounts that have at least 1 campaign sent']
      },
      {
        type: CHART_TYPES.GRAPH,
        name: 'TotalCampaignsCreatedAndSendPerDay',
        title: 'Campaign totals',
        tooltip: ['Total Campaigns Created: shows the accumulated number of campaigns created', 'Total Campaigns Sent: shows the accumulated number of campaigns sent']
      }
    ],
    route: '/financial-reports/email-marketing/overview',
    brandSelection: true,
    extendedBrandSelection: [Partners.GATOR.id, Partners.CTCTBUILDER.id, Partners.CREATIVEMAIL.id]
  },
  salesCe: {
    charts: [
      {
        type: CHART_TYPES.TABLE,
        title: 'Upgrades through Creative Email',
        name: 'UpgradesThroughEmail'
      },
      {
        type: CHART_TYPES.TABLE,
        title: 'One Off Campaign',
        name: 'OneOffCampaigns'
      }
    ],
    route: '/financial-reports/email-marketing/sales',
    brandSelection: true,
    extendedBrandSelection: [Partners.GATOR.id, Partners.CTCTBUILDER.id, Partners.CREATIVEMAIL.id],
    disableToday: true
  },
  satisfactionCe: {
    charts: [
      {
        type: CHART_TYPES.TABLE,
        title: 'Satisfaction',
        name: 'NpsEmail',
        className: 'grid-col-6'
      },
      {
        type: CHART_TYPES.GRAPH,
        title: 'Satisfaction trend',
        name: 'NpsEmailTrendsPerDay'
      },
      {
        type: CHART_TYPES.CARD,
        title: 'Supporting comments',
        name: 'NpsEmailSupportingCommentsTotal'
      },
      {
        type: CHART_TYPES.TABLE,
        title: 'Satisfaction comments',
        name: 'NpsEmailComments',
        enableCaching: false,
        sorting: { default: { fieldNames: ['date'], direction: true } },
        headers: [
          {
            type: 'nps-multi-select',
            disableRouteClick: true
          },
          {
            name: 'AccountId',
            title: 'Account Id',
            type: 'account',
            disableRouteClick: true
          },
          {
            name: 'Email',
            title: 'Email',
            type: ''
          },
          {
            name: 'Phone',
            title: 'Phone',
            type: ''
          },
          {
            name: 'Partner',
            title: 'Partner',
            type: ''
          },
          {
            name: 'Score',
            title: 'Score',
            type: 'number'
          },
          {
            name: 'Comment',
            title: 'Comment',
            type: ''
          },
          {
            name: 'CustomerType',
            title: 'Customer Type',
            type: ''
          },
          {
            name: 'Date',
            title: 'Date',
            type: 'date'
          },
          {
            name: 'Time',
            title: 'Time',
            type: 'datetime'
          },
          {
            name: 'AgentId',
            title: 'Agent Id',
            type: ''
          },
          {
            name: 'Note',
            title: 'Note',
            type: ''
          },
          {
            name: 'Status',
            title: 'Status',
            type: ''
          },
          {
            type: 'nps-edit-column',
            disableRouteClick: true
          }
        ]
      }
    ],
    route: '/financial-reports/email-marketing/satisfaction'
  },
  usageCe: {
    charts: [
      {
        type: CHART_TYPES.GRAPH,
        name: 'AccountsAndCampaignsPerDay',
        title: 'Account and Campaign data',
        tooltip: ['Accounts Created: shows the number of CTCT Accounts created on a specific date', 'Campaigns Created: shows the number of campaigns created on a specific date', 'Campaigns Sent: shows the number of campaigns sent on a specific date']
      },
      {
        type: CHART_TYPES.HEAT_TABLE,
        name: 'timetofirstemailsent',
        title: 'Time to first email sent',
        tooltipFormatterVerb: 'sent',
        tooltipFormatterDirectObject: 'first email'
      },
      {
        type: CHART_TYPES.TABLE,
        name: 'LatestEmailAccounts',
        title: 'Newest Accounts',
        limit: 500,
        headers: [
          {
            name: 'ReferenceAccountId',
            title: 'Account',
            type: 'account'
          },
          {
            name: 'EmailAddress',
            title: 'Email address',
            type: ''
          },
          {
            name: 'TimeCreated',
            title: 'Created on',
            type: 'datetime'
          },
          {
            name: 'Site',
            title: 'Site ID',
            type: 'number'
          },
          {
            name: 'CampaignsCreated',
            title: 'Campaigns created',
            type: 'number'
          },
          {
            name: 'CampaignsSend',
            title: 'Campaigns sent',
            type: 'number'
          },
          {
            name: 'CampaignsScheduled',
            title: 'Campaigns scheduled',
            type: 'number'
          },
          {
            name: 'TotalContacts',
            title: 'Subscribers',
            type: 'number'
          },
          {
            name: 'Status',
            title: 'Status',
            type: ''
          },
          {
            name: 'VerifiedOn',
            title: 'Verified on',
            type: 'datetime'
          },
          {
            name: 'SetupCompletedOn',
            title: 'Setup completed on',
            type: 'datetime'
          },
          {
            name: 'Brand',
            title: 'Brand',
            type: ''
          }
        ]
      }
      // {
      //   type: CHART_TYPES.GRAPH,
      //   name: 'AccountsWithCampaignsPerDay',
      //   title: 'Accounts with campaigns'
      // },
      // {
      //   type: CHART_TYPES.GRAPH,
      //   name: 'AccountsWithCampaignsSendPerDay',
      //   title: 'Accounts with campaigns sent'
      // }
      // {
      //   type: CHART_TYPES.GRAPH,
      //   name: 'CampaignsScheduledPerDay',
      //   title: 'Campaigns scheduled'
      // },
    ],
    route: '/financial-reports/email-marketing/usage',
    brandSelection: true,
    extendedBrandSelection: [Partners.GATOR.id, Partners.CTCTBUILDER.id, Partners.CREATIVEMAIL.id]
  }
}
